export default {
    menu_label: 'Outreach tasks',

    heading: 'Outreach tasks',

    filters: {
        from_date: 'From date',
        to_date: 'To date',
    },

    table: {
        task_id: 'Task ID',
        type: 'Type',
        pool_id: 'Pool ID',
        provider: 'Provider',
        npi: 'NPI',
        channel: 'Channel',
        reason: 'Reason',
        error_code: 'Error / Code',
        constrained_details: 'Code',
        status: 'Status',
        actions: 'Actions',
        resend: 'Resend',
        scheduled_for: 'Scheduled for',
        sent_at: 'Sent at',
        created_at: 'Created at',
        no_tasks: 'No outreach tasks found',
    },

    modal: {
        title: 'Outreach task details',
    },

    constrained: 'Constrained',

    outreach_type: {
        constrained: 'Constrained',
        external: 'Unmatched',
    },

    reason: 'Reason',

    confirm_resend: 'Are you sure you want to resend this outreach task?',
    resend_failed: 'Failed to resend outreach task.',

    status: {
        PENDING: 'Pending',
        PROCESSING: 'Processing',
        PROCESSED: 'Sent',
        FAILED: 'Failed',
        CANCELLED: 'Cancelled',
    },

    channel: {
        fax: 'Fax',
        email: 'Email',
        sms: 'SMS',
    },

    pagination: {
        info: 'Page {current} of {total}',
    },

    notifications: {
        load_failed: 'Failed to load outreach tasks',
    },
}
